import { useCamps } from '@/lib/hooks'
import { CampsGrid } from '@/components/sections/CampsGrid'
import { PageHero } from '@/components/layout/PageHero'

export function CampsPage() {
  const { data: camps = [] } = useCamps()
  return (
    <>
      <PageHero
        eyebrow="Seasonal &amp; Year-Round"
        title="Camps."
        intro="Four camp formats scheduled throughout the year — Summer, Competitive, Holiday, and Advance. Open to Cosmos members and outside players."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/Z4-1024x768.jpg"
        crumbs={[{ label: 'Camps' }]}
      />
      <section className="py-20">
        <div className="container-narrow">
          <CampsGrid camps={camps} />
        </div>
      </section>
    </>
  )
}
